import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import MachineList from '../components/MachineList';
import MachineSearchResult  from '../components/MachineSearchResult';
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import { Link } from 'react-router';
import CircularProgress from 'material-ui/CircularProgress';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Add from 'material-ui/svg-icons/content/add';
import PageLoading from '../components/PageLoading';
import right_corner_style from '../utils/right-corner-style';
import SelectCustomer from '../components/SelectCustomer';
import TextField from 'material-ui/TextField';
import {uiMsg} from '../utils/Languages';

import CustomerMachineList from '../components/CustomerMachineList';


const listStyle = {
  margin: 24
};

const searchBoxStyle = {
  float: 'right',
  marginTop: -20,
  marginRight: 15
};

export default
@observer class MachinesAdminPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }
  constructor(props){
    super(props);

    this.state = {
      searchTerm: ''
    }
  }

  gotoNewMachinePage() {
    this.context.router.push('/machine_admin/newMachine');
  }

  // Goto detail page for machine :
  gotoMachineDetail(machine) {
    this.context.router.push(`/machines/admin_machine/${encodeURI(machine.id_customer)}/${encodeURI(machine.id)}`);
  }

  loadCustomerWithMachine(event) {
      this.setState({ searchTerm: event.target.value })
      AppModelUtils.fetch_customer_list(event.target.value);
  }

  render() {
    return (
      <div>
        <TextField floatingLabelText={uiMsg('ML_SEARCH',"Search")}
                   hintText={uiMsg('ML_SEARCH_HINT',"Machine name or id")}
                   onChange={this.loadCustomerWithMachine.bind(this)}
                   fullWidth={false}
                   style={searchBoxStyle}
        />
        <div style={listStyle}>
          <PageLoading loading={AppModel.customerListLoading}>
            <CustomerMachineList
              customers={AppModel.customerListIncludingOwnCompany}
              onSelect = {this.gotoMachineDetail.bind(this)}
              searchTerm={this.state.searchTerm}
            />

            {AppModel.canRegisterMachines?
              <FloatingActionButton style={right_corner_style}
                                  children={<Add />}
                                  onTouchTap={this.gotoNewMachinePage.bind(this)} />
              :null
            }

          </PageLoading>
        </div>
      </div>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/MachinesAdminPage.jsx
 **/